import { SHOW_EVENT, SUCCESS_EVENT } from './constants.tsx';
import type {
	TransitionScreenShowEvent,
	TransitionScreenEvent,
	TransitionScreenSuccessEvent,
} from './types.tsx';

export function isShowEvent(event: TransitionScreenEvent): event is TransitionScreenShowEvent {
	return event.type === SHOW_EVENT;
}

export function isSuccessfulEvent(
	event: TransitionScreenEvent,
): event is TransitionScreenSuccessEvent {
	return event.type === SUCCESS_EVENT;
}
